<template>
  <div
      :class="['map', 'x' + stepScale]"
      :style="{
        'width': (stepScale === 1 ? width : 0) + 'px',
        'height': (stepScale === 1 ? height : 0) + 'px',
        'transform': stepScale === 1 ? 'translate(' + (x + tx) + 'px, ' + (y + ty) + 'px) scale(' + scale + ')' : '',
        'position': stepScale === 1 ? 'absolute' : 'static',
        'will-change': stepScale === 1 ? 'transform' : ''
      }"
  >
    <MapX2
        v-for="item of sub"
        :key="Math.random(item)"
        :x="item.x"
        :y="item.y"
        :width="item.width"
        :height="item.height"
        :els="item.els"
        :sub="item.sub"
        :tx="tx"
        :ty="ty"
        :scale="scale"
        :cw="cw"
        :ch="ch"
        :step-scale="stepScale"
        :vl="vl"
    />
  </div>
</template>

<script>
import MapX2 from "@/components/x1/MapX2";
export default {
  name: "MapX1",
  components : { MapX2 },
  props: {
    x: Number,
    y: Number,
    width: Number,
    height: Number,
    els: Array,
    sub: Array,
  },
  data: () => ({
    tx: 0,
    ty: 0,
    scale: 1,
    cw: 0,
    ch: 0,
    rtx: 0,
    rty: 0,
    rscale: 0,
    btx: 0,
    bty: 0,
    bscale: 0,
    beginTime: 0,
    endTime: 0,
    isAnim: false
  }),
  computed: {
    stepScale () {
      if (this.scale <= 1) {
        return 1;
      }
      if (this.scale <= 2) {
        return 2;
      }
      if (this.scale <= 4) {
        return 4;
      }
      if (this.scale <= 8) {
        return 8;
      }
      if (this.scale <= 16) {
        return 16;
      }
      if (this.scale <= 32) {
        return 32;
      }
      return this.scale;
    },
    vl () {
      return this.scale < 3 ? 0 : this.scale < 9 ? 1 : this.scale < 17 ? 2 : 3;
    }
  },
  created () {
    let ts = this;

    document.onmousedown = press => {
      let tx = ts.tx;
      let ty = ts.ty;

      press.preventDefault();

      document.onmousemove = move => {
        ts.tx = ts.rtx = tx + (move.screenX - press.screenX);
        ts.ty = ts.rty = ty + (move.screenY - press.screenY);
        move.preventDefault();
      }

      document.onmouseup = up => {
        document.onmousemove = null;
        document.onmouseup = null;
        up.preventDefault();
      }
    }

    document.onwheel = wheel => {
      let step = ts.stepScale;
      let cscale = ts.rscale || ts.scale;
      let ctx = ts.rtx || ts.tx;
      let cty = ts.rty || ts.ty;
      let nscale;

      if (wheel.deltaY < 0) {
        let v = cscale + 0.1 * step;

        if (v < 32) {
          nscale = v;
        }
        else {
          nscale = 32;
        }
      }
      else {
        let v = cscale - 0.1 * step;

        if (v > 0.5) {
          nscale = v;
        }
        else {
          nscale = 0.5;
        }
      }

      ts.animTo(
          ctx - (nscale - cscale) * (wheel.clientX - ctx) / cscale,
          cty - (nscale - cscale) * (wheel.clientY - cty) / cscale,
          nscale
      );
    }
    
    window.onkeypress = () => {
      document.onwheel({deltaY: -1, clientX: 0, clientY: 0});
    }

    window.onresize = () => {
      ts.cw = window.innerWidth;
      ts.ch = window.innerHeight;
    }

    window.onresize();
  },
  methods: {
    animTo (x, y, scale) {
      this.rtx = x;
      this.rty = y;
      this.rscale = scale;
      this.btx = this.tx;
      this.bty = this.ty;
      this.bscale = this.scale;

      this.beginTime = new Date().getTime();
      this.endTime = this.beginTime + 300;

      if (!this.isAnim) {
        this.isAnim = true;

        let update = () => {
          let now = new Date().getTime();

          if (now > this.endTime) {
            this.isAnim = false;
            this.tx = this.rtx;
            this.ty = this.rty;
            this.scale = this.rscale;
          }
          else {
            let progress = (now - this.beginTime) / 300;
            let step = Math.cos(Math.PI * progress) - 1;

            this.tx = -(this.rtx - this.btx) / 2 * step + this.btx;
            this.ty = -(this.rty - this.bty) / 2 * step + this.bty;
            this.scale = -(this.rscale - this.bscale) / 2 * step + this.bscale;

            window.requestAnimationFrame(update);
          }
        };

        window.requestAnimationFrame(update);
      }
    }
  }
}
</script>
